const AllegatiStampone = [
    "application/pdf",
]

export default AllegatiStampone;
